<template class='HomePagefooter'>
  <div> 
    <div class="footer pc" v-if="showFooter">
            <!-- <div  class="foot" style="color:#fff;padding-bottom:1.718vw;padding-top:3.073vw;" > -->
            <div  class="foot" style="color:#fff" >
                <!-- <div style="text-align:center;">
                    <img src="../assets/image/homePage/index/PCImage/footer_logo.png" alt="logo" style="height:3vw;width:13.8vw;">
                </div> -->
            
                <div style="display: flex;justify-content: center;" class="content">
                    


                    <div style="font-family:SHS-R;">
                        <div style="display: flex;justify-content: flex-start;">
                            <div style="margin-right:2.760vw;font-size:0.8333vw;font-family:SHS-R;display:flex">
                                <!-- 客服热线<br> -->
                                <img src="../assets/image/homePage/index/PCImage/telphone_icon_foot.png" style="margin-right:11px">
                                <p style="font-size:1.093vw;font-family:SHS-R;font-weight: normal;line-height:30px;">400 6688 991</p>
                            </div>
                            <div style="font-size:0.8vw;font-family:SHS-R;display:flex">
                                <!-- 邮箱<br> -->
                                <img src="../assets/image/homePage/index/PCImage/email_icon_foot.png" style="margin-right:11px" >
                            <p style="font-size:1.093vw;font-family:SHS-R;font-weight: normal;line-height:30px;">IL@imaginelearning.cn</p>
                            </div>
                        </div>
                        <!-- <p style="font-size:0.8333vw; margin:1.2vw 0px 0.573vw 0;">关注我们</p> -->
                        <div style='display: flex;justify-content: flex-start;font-size:0.7292vw;text-align:center; margin-bottom:4.6354167vw'>
                            <div style="margin-right:4.01vw; margin-top:2.656vw">
                                <div style='width:6.25vw;height:6.25vw;'>
                                <img src="../assets/image/homePage/index/PCImage/imagine_school.png" alt="想象力校园" style="width:6.25vw;height:6.25vw;">
                                </div>
                                <p style="margin-top:16px;font-size:0.78125vw;line-height:1.1vw;">想象力校园</p>
                            </div>
                            <div style="margin-top:2.656vw">
                                <div style='width:6.25vw;height:6.25vw;'>
                                <img src="../assets/image/homePage/index/PCImage/imagine_english.png" alt="想象力家长" style="width:6.25vw;height:6.25vw;">
                                </div>
                                <p style="margin-top:16px;font-size:0.78125vw;line-height:1.1vw;">想象力家长</p>
                            </div>
                        </div>
                    </div>
                </div>
            
            </div>
            <!-- <div class="banquan" style="line-height:7.4vw;height:7.4vw;text-align:center;background:#ffffff;font-size:1.0416vw;font-family:SHS-R;color:#666;"> -->
            <div class="banquan" style="text-align:center;">
             <a href="https://beian.miit.gov.cn/" target="_blank">©2021 想象力教育科技有限公司     沪ICP备19026406号</a>
              
              <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011502013557" style="display:flex;align-items: center;text-decoration:none;height:20px;margin-left: 10px;margin-bottom: 0;">
                <img style="width:20px;height:20px;margin-right:4px;" src="../assets/icon_record.png">
                <p style="height:20px;line-height:20px;margin: 0px 0px 0px 0px; color:#fff;">沪公网安备
                  31011502013557号</p>
              </a>

            </div>
        </div>
    <div class="phone" v-if="showFooter">
         <div class="footerBox" >
             <div class="footBG">
                 <!-- <div class="footLogoBox" @click="ycCode" >
                     <img src="../assets/image/homePage/index/PhoneImage/bot_logo@2x.png" alt="">
                 </div> -->
                 <div class="footDes">
                      <div class="footFirst" @click="ycCode">
                           <div  class="footTit footPhoneNum" >全国热线</div>
                           <div class="phoneNum" style="font-size:3vw;">400 6688 991</div>
                           <div  class="footTit footEmail" >邮箱</div>
                           <div  style="font-size:3vw">IL@imaginelearning.cn</div>
                      </div>
                      <div class="footsecond">
                            <div class="footTit">
                                关注我们
                            </div>
                             <div  class="wxlogoSDes" @click="showCode(1)">
                                <span class="wxImgbox"><img src="../assets/image/homePage/index/PhoneImage/xiaoyuan@2x.png" alt="" style="width:5.33vw;height:5.33vw"></span>
                                <span style="position:relative;" >&nbsp;想象力校园
                                 <div class="erWeiMaSize" v-if="codeIndex===1" @click="ycCode"><img src="../assets/image/homePage/index/PCImage/imagine_school.png"  alt="" style=""></div>
                                </span>
                            </div>
                             <div  @click="showCode(2)">
                                <span class="wxImgbox"><img src="../assets/image/homePage/index/PhoneImage/jiazhang@2x.png" alt="" style="width:5.33vw;height:5.33vw"></span>
                                <span style="position:relative;">&nbsp;想象力家长
                                 <div class="erWeiMaSize" @click="ycCode" v-if="codeIndex===2" ><img src="../assets/image/homePage/index/PCImage/imagine_english.png"  alt="" style=""></div>
                                </span>
                            </div> 
                      </div>
                 </div>

             </div>
            <div class="banquanXXL">
                <div class="vertion-phone"><a href="https://beian.miit.gov.cn/" target="_blank">©2021 想象力教育科技有限公司     沪ICP备19026406号</a></div>
                 <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011502013557" style="display:flex;align-items: center;text-decoration:none;height:20px;margin-left: 10px;margin-bottom: 0;">
                    <img style="width:20px;height:20px;margin-right:4px;" src="../assets/icon_record.png">
                    <p style="height:20px;line-height:20px;margin: 0px 0px 0px 0px; color:#fff;">沪公网安备
                      31011502013557号</p>
                  </a>
            </div>
         </div>
    </div>
</div> 
</template>
<script>
import Bus from 'config/bus';
export default {
  data() {
    return {
    //    codeFlag:flase,
        codeIndex:'',
        showFooter:""
    };
  },
  created() {
  },
  mounted(){
      Bus.$on('codeIndex', (val) => {　
                    this.codeIndex = "";
				})
      Bus.$on('footdisapperar', (val) => {　
        console.log(val)
                    this.showFooter = val;
				})
  },
  methods:{
      showCode(index){
         this.codeIndex=index;
      },
     ycCode(){
        this.codeIndex='';
     }
  }

};
</script>
<style scoped lang="scss">
@media screen and (min-width: 992px) {
    .phone{
        display: none;
    }
     a:link,a:visited{color:#666;text-decoration:none;}
    a:hover{color: #666666;}
    .footNav{
        color: #fff !important;
    }
    
}
@media screen and (max-width: 993px){
    .phone{
        display: block;
    }
    .pc{
        display: none;
    }
    .show{
        display: block;
    }
    .erWeiMaSize{
        /* display: none; */
       width:22.93vw;
       height:23.06vw;
       position:absolute;
       top:-20.393vw;
       left:-3.5vw;
       z-index: 1000000;
    }
    .erWeiMaSize>img{
        width:100%;
        height: 100%;
    }
    .footerBox{
        width: 100%;
        // height: 70.26667vw /* 527/75 */;
        height: 100%;
        color: #ffffff;
    }
    .footPhoneNum{
        margin-bottom: 1.2vw /* 9/75 */;
    }
    .footEmail{
        margin-top: 2.26667vw /* 17/75 */;
        margin-bottom: 1.46667vw /* 11/75 */;
    }
    .wxImgbox{
        display: inline-block;
        height: 5.86667vw /* 44/75 */;
        width:6.93333vw /* 52/75 */;
        line-height: 5.86667vw;
        margin-right: 2.26667vw /* 17/75 */;
        vertical-align: middle;
        
    }
    .wxlogoFDes img{
        width: 100%;
        height: 100%;
    }


    .wxlogoFDes{
        display: flex;
        height: 5.86667vw /* 44/75 */;
        width:100% /* 52/75 */;
        line-height: 5.86667vw;
        margin-top: 2.26667vw/* 17/75 */;
        font-size: 2.66667vw /* 20/75 */;
    }
    
    .wxlogoSDes{
        height: 5.86667vw /* 44/75 */;
        width:100% /* 52/75 */;
        line-height: 5.86667vw;
        margin-top: 2.26667vw;
         margin-bottom: 2.26667vw /* 17/75 */
    }
    .banquanXXL{
        display: flex;
        flex-direction: column;
        align-items: center;
        /* height: 10.66667vw 80/75; */
        // height:vt(49);
        text-align:center;
        background:#132656;
        font-size:2.133vw;
        font-family:SHS-R;
        color:#fff;
        // margin-bottom: 42.6667px;
        .vertion-phone>a{
            color: #fff;
            // line-height: vt(49);
            opacity: .8;
            text-decoration:none;
        }
    }
    // .vertion-phone,.beiAn{
    //    line-height: 5.133vw;
    // }
    // .beiAn a:link,.beiAn a:visited{color:#666;text-decoration:none;}
    .footBG{
        // height: 59.6vw /* 447/75 */;
        // background-image: url(../assets/image/homePage/index/PhoneImage/back.png);
        // background-size: 100% 100%;
        height: vt(138);
        background-color: #162b63;
        padding-top: vt(19);
    }
    .footLogoBox{
        height: 22.4vw /* 168/75 */;
        text-align: center;
        line-height: 22.4vw;
    }
    .footLogoBox>img{
        margin-top: 7.33vw;
        width: 35.2vw /* 264/75 */;
        height: 7.73333vw /* 58/75 */;
    }
    .footDes{
        height: 37.2vw;
        text-align: left;
    }
    .footFirst{
        padding-left: 6.66667vw /* 50/75 */;
        width: 50%;
        float: left;
        font-size: 4vw /* 30/75 */;
        box-sizing: border-box;
        font-family: SHS-R;
    }
     .footsecond{
        text-align: left;
        width: 50%;
        padding-left: 7.33333vw /* 55/75 */;
        float: right;
        box-sizing: border-box;
        font-family: SHS-R;
    }
   
    .footTit{
        color: #999;
        font-size: 4vw /* 30/75 */;
        font-family: SHS-R;
    }
    .footsecond>div{
        width:100%;
    }
    .footsecond>div img{
        width:100%;
        height: 100%;
    }
    .footsecond span{
        font-size:2.66667vw /* 20/75 */;
    }
    .phoneNum{
        font-size: 5.33333vw /* 40/75 */;
        font-family: SHS-R;
    }
}
*{
    padding: 0;
    margin: 0;
    
}
ul{
    list-style:none;
}
li{
    // padding-top: 5px;
    // margin-top: 11px;
    margin-bottom: vp(11);
    height: 100%;
    text-align: left;
}
.foot{
    /* background: url(../assets/image/homePage/index/PCImage/footer_back_01.png); */
    background-color: #04306B;
    // background-size: 100% 100%;
    // height: vp(375);
    .content{
        padding-top: vp(63);
    }
}
.banquan{
    background-color: #032A5D;
    height: vp(79);
    font-size: vp(15);
    margin-bottom: vp(65);
    display: flex;
    justify-content: center;
    align-items: center;
    a{
        color: #fff;
        display: block;
        font-family:SHS-R;
    }
}
.line{
    width: vp(91);
    height: 1px;
    background-color: #284767;
    padding-top: 0;
    margin-top: 11px;
}
.special>li{
    opacity: .7;
}
.footMove{
    float: right;
    margin-top: vp(-100);
    
}
</style>





// WEBPACK FOOTER //
// src/components/HomePageFooter.vue